export const activityStatus = {
  bloqueada: "sesión bloqueada",
  desbloqueada: "sesión desbloqueada",
  completa: "completa",
};
